module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.year),
      expression: "year"
    }],
    staticClass: "m-b-10",
    attrs: {
      "placeholder": "请选择年份"
    },
    domProps: {
      "value": (_vm.year)
    },
    on: {
      "change": _vm.getData,
      "input": function($event) {
        _vm.year = $event
      }
    }
  }, _vm._l((_vm.yearOptions), function(option) {
    return _c('el-option', {
      attrs: {
        "label": option.name,
        "value": option.id
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "tx-c m-b-10"
  }, [_vm._v("工程质安数据统计")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "start",
      "label": "开工项目",
      "width": "600"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "end",
      "label": "竣工项目"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-54e28516!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Self/projectQuality.vue
// module id = 1868
// module chunks = 2